import type { Database } from "../../__definitions__/database-definitions";
import yup, { yupUUID } from "../../utils/yup";

export type WhatsAppTemplate = Database["public"]["Tables"]["whatsapp_template"]["Row"];
export type WhatsAppMoment = Database["public"]["Tables"]["whatsapp_moment"]["Row"];
export type WhatsAppDestinationType = "page" | "content_library" | "url";

const absoluteHttpUrl = yup
  .string()
  .trim()
  .test("absolute-http-url", "Enter an absolute HTTP(S) URL", (value) => {
    if (!value || /{{.*}}/.test(value)) return false;
    try {
      const url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  });

export const whatsappMomentSchema = yup.object({
  destination_type: yup
    .string<WhatsAppDestinationType>()
    .oneOf(["page", "content_library", "url"])
    .required()
    .default("page"),
  digital_asset_id: yupUUID
    .nullable()
    .when("destination_type", {
      is: "content_library",
      then: (schema) => schema.required("Select a file from Content Library"),
      otherwise: (schema) => schema.nullable(),
    })
    .default(null),
  url: yup
    .string()
    .nullable()
    .when("destination_type", {
      is: "url",
      then: () => absoluteHttpUrl.required("Enter a destination URL"),
      otherwise: (schema) => schema.nullable(),
    })
    .default(null),
});
